// extracted by mini-css-extract-plugin
export default {"Card":"Global_Card__nTxAV"};